import React from "react";
import type { ApprovalPolicyPageLoaderData } from "~/areas/library/components/ApprovalPolicies/CreateOrEditApprovalPolicyPage";
import { CreateOrEditApprovalPolicyPage } from "~/areas/library/components/ApprovalPolicies/CreateOrEditApprovalPolicyPage";
interface CreateApprovalPolicyPageProps {
    spaceId: string;
    loaderData: ApprovalPolicyPageLoaderData;
}
export function CreateApprovalPolicyPage({ spaceId, loaderData }: CreateApprovalPolicyPageProps) {
    return <CreateOrEditApprovalPolicyPage spaceId={spaceId} create={true} loaderData={loaderData} id={undefined}/>;
}
